<template>
  <div>
    <el-table
      border
      stripe
      :data="tableData"
      style="width: 100%"
      :row-style="{height:'40px'}"
      size="mini"
      v-loading="listLoading"
      :header-cell-style="{background:'#D7D7D7',color:'#000'}"
      :header-cell-class-name="ocopHeaderLineHeightStyle"
      :cell-class-name="ocopColumnZebraStyle"
      row-key="id"
    >
      <el-table-column prop="code" label="Item Code" width="190" fixed></el-table-column>
      <el-table-column prop="name" label="Item Name" width="370" fixed></el-table-column>
      <el-table-column label="Stock" width="70px" fixed align="right">
        <template v-slot="scope">
          <ColumnStockDropDown :row="scope.row" :rowId="scope.row.id" />
        </template>
      </el-table-column>
      <el-table-column
        prop="stock_3rdP"
        label="3rdP Stk"
        width="85"
        align="right"
        class-name="table-column-stock-type-color"
        fixed
      ></el-table-column>
      <el-table-column
        prop="classAPrice"
        label="A price"
        width="73"
        align="right"
        class-name="table-column-class-type-color"
        fixed
      ></el-table-column>
      <el-table-column
        prop="classBPrice"
        label="B price"
        width="73"
        align="right"
        class-name="table-column-class-type-color"
        fixed
      ></el-table-column>
      <el-table-column
        prop="specialPrice"
        label="Special"
        width="83"
        align="right"
        class-name="table-column-sale-type-color"
        fixed
      ></el-table-column>
      <el-table-column
        prop="standardPrice"
        label="VIP price"
        width="73"
        align="right"
        class-name="table-column-sale-type-color"
        fixed
      ></el-table-column>
      <el-table-column
        prop="costPrice"
        label="Cost"
        width="70"
        align="right"
        class-name="table-column-cost-type-color"
        fixed
      ></el-table-column>
      <el-table-column
        prop="ref_pur"
        label="Tempe"
        width="70"
        align="right"
        class-name="table-column-cost-type-color"
        fixed
      ></el-table-column>
      <el-table-column
        prop="classCPrice"
        label="C price"
        width="73"
        align="right"
        class-name="table-column-ocop-type-color"
        fixed
      ></el-table-column>
      <el-table-column
        prop="classDPrice"
        label="D price"
        width="73"
        align="right"
        class-name="table-column-ocop-type-color"
        fixed
      ></el-table-column>
      <el-table-column
        prop="classEPrice"
        label="E price"
        width="73"
        align="right"
        class-name="table-column-ocop-type-color"
        fixed
      ></el-table-column>
      <el-table-column
        v-for="csr of csrs"
        :key="csr.id"
        :label="csr.name"
        :prop="'ocop[' + csr.id + ']'"
        align="right"
        class-name="test"
      ></el-table-column>
      <el-table-column label="Action" fixed="right" align="center" min-width="190">
        <template v-slot="scope">
          <el-button
            icon="el-icon-edit"
            type="info"
            plain
            round
            size="mini"
            @click="handleEdit(scope.row)"
          >OCOP</el-button>
          <el-button
            type="primary"
            icon="el-icon-edit-outline"
            round
            size="mini"
            @click="handleEditStdSAB(scope.row)"
          >Edit Prices</el-button>
        </template>
      </el-table-column>
      <div slot="empty">
        <span class="list-table-empty-text">{{emptyInfo}}</span>
      </div>
    </el-table>
    <slot name="pagination"></slot>
    <DialogOcopEdit
      :dialogVisible="editShow"
      @closed="editShow=false"
      @success="handleSuccess"
      :product="product"
      :ocop="ocop"
    />
    <DialogStdSABEdit
      :dialogVisible="editShowStdSAB"
      @closed="editShowStdSAB=false"
      @success="handleSuccessStdSAB"
      :product="productStdSAB"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { ocopDetail } from '../api'
import DialogOcopEdit from './DialogOcopEdit'
import DialogStdSABEdit from './DialogStdSABEdit'
import ColumnStockDropDown from './ColumnStockDropDown'
import { Message } from 'element-ui'

export default {
  name: 'OcopResults',
  components: {
    DialogOcopEdit,
    DialogStdSABEdit,
    ColumnStockDropDown
  },
  computed: {
    ...mapState('search', {
      listLoading: 'listLoading',
      tableData: 'lists',
      isNewEnter: 'isNew',
      csrs: 'ocopCrs'
    }),
    emptyInfo () {
      return this.isNewEnter ? 'Enter or Select Filters to Search' : 'No Data'
    }
  },
  data () {
    return {
      product: {},
      productStdSAB: {},
      ocop: [],
      editShow: false,
      editShowStdSAB: false
    }
  },
  methods: {
    ocopHeaderLineHeightStyle ({ columnIndex }) {
      if (columnIndex > 4) {
        return 'ocopHeaderLineHeightStyle'
      }
    },
    ocopColumnZebraStyle ({ columnIndex }) {
      if (columnIndex > 2 && columnIndex % 2 !== 0) {
        return 'table-cell-ocop-odd-column-zebra-style'
      } else if (columnIndex > 2 && columnIndex % 2 === 0) {
        return 'table-cell-ocop-even-column-zebra-style'
      }
    },
    async handleEdit (row) {
      const { csrs, data } = await ocopDetail(row.id)
      const { ocop, ...product } = data
      this.product = product
      this.ocop.splice(0)

      csrs.forEach(csr => {
        const price = ocop[csr.id] || 0
        this.ocop.push({ id: csr.id, name: csr.name, price: price })
      })

      this.editShow = true
    },
    async handleEditStdSAB (row) {
      const roleObj = JSON.parse(localStorage.getItem('role-fone') || '{}')
      if (!roleObj.modPrc) {
        Message.warning({
          showClose: true,
          duration: 3500,
          dangerouslyUseHTMLString: true,
          message: 'Sorry, no permission to modify the prices.'
        })
        return
      }

      const { data } = await ocopDetail(row.id)
      const { ...product } = data
      this.productStdSAB = product
      this.editShowStdSAB = true
    },
    ...mapActions({
      search: 'search/search'
    }),
    handleSuccess () {
      this.search()
      this.editShow = false
    },
    handleSuccessStdSAB () {
      this.search()
      this.editShowStdSAB = false
    }
  },
  provide () {
    return {
      isProductList: true
    }
  }
}
</script>
